
import React, { useContext } from 'react'
import * as translator from "../../../../utils/translator"
import { RouterCartContext } from '../../ChooseTreatmentRouter'

type Props = {
    languageID: string,
    onClick: () => void,
    className?: string,
    desktop?: boolean
    disabled?: boolean,
}

const SubmitButton: React.FC<Props> = ({onClick, desktop, disabled,languageID, className}) => {

  const routerCartContext:any = useContext(RouterCartContext);
  const cart = routerCartContext.cartData;
  const isSelfPickup = cart?.self_pickup_pharmacy_id ? true : false;


  const styleBasedOnDisabled = () => {
    if (disabled) {
      return `opacity-60 px-2 py-5 text-white text-center font-bold ${className} cursor-not-allowed rounded-md bg-primary-button-gradient-hover `
    }
    return `cursor-pointer rounded-md bg-primary-button-gradient p-5 text-white text-center font-bold hover:opacity-90 transition-opacity ${className}`
  }

  return (
    <div id={desktop ? "desktop-choose-treatment-submit-button" : "mobile-choose-treatment-submit-button"} onClick={disabled ? () => {} : onClick} className={styleBasedOnDisabled()}>
        <p id='submit-button-text'>
          {`
            ${translator.translate(languageID,"default", `DrugSelectionSidePanel/${isSelfPickup ? "button-text-self-pickup" : "button-text"}`)} 
          `}
        </p>
    </div>
  )
}

export default SubmitButton
